import { useDispatch } from "react-redux";
import { useLazyGetPaymentListQuery } from "../../../Store/Builder/techsbook.api";
import showToast from "../../Hooks/toast";
import { setLoader, setPaymentList } from "../../../Store/Slice/techsbookSlice";

const useGetPaymentList = () => {
  const dispatch = useDispatch();
  const [getPayment] = useLazyGetPaymentListQuery();

  const get = () => {
    dispatch(setLoader(true));
    getPayment()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setPaymentList(res));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };
  return {
    get,
  };
};

export default useGetPaymentList;
